import { Component, OnInit } from '@angular/core';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { FieldType } from '@ngx-formly/core';
import { AssessmentService } from 'src/app/core/service/assessment.service';

/** Required when templateOptions.required: at least one option must be true. */
export function multicheckboxHasSelectionValidator(): ValidatorFn
{
  return (control: AbstractControl): ValidationErrors | null =>
  {
    const value = control.value;
    if (value == null || typeof value !== 'object' || Array.isArray(value))
    {
      return { required: true };
    }

    return Object.values(value).some((entry) => entry === true) ? null : { required: true };
  };
}

@Component({
  standalone: false,
  selector: 'app-formly-field-multi-checkbox',
  templateUrl: './formly-field-multi-checkbox.component.html',
  styleUrls: ['./formly-field-multi-checkbox.component.scss']
})
export class FormlyFieldMultiCheckboxComponent extends FieldType implements OnInit
{
  constructor(private assessmentService: AssessmentService)
  {
    super();
  }

  public ngOnInit(): void
  {
    this.ensureObjectControlValue();
    this.applyRequiredSelectionValidator();
  }

  public onChange(value: any, checked: boolean): void
  {
    this.ensureObjectControlValue();

    const current = this.formControl.value;
    // Always emit so Formly syncs this.model — save/update persists the model, not the control alone.
    // Keep explicit false when unchecked (do not collapse to null).
    if (typeof current !== 'object' || current === null || Array.isArray(current))
    {
      this.formControl.patchValue({ [value]: checked });
      this.formControl.markAsTouched();
      return;
    }

    this.formControl.patchValue({ ...current, [value]: checked });
    this.formControl.markAsTouched();
  }

  private applyRequiredSelectionValidator(): void
  {
    if (!this.formControl || !this.to?.required)
    {
      return;
    }

    // Angular Validators.required treats { option: false } as present; require at least one true.
    this.formControl.addValidators(multicheckboxHasSelectionValidator());
    this.formControl.updateValueAndValidity({ emitEvent: false });
  }

  private ensureObjectControlValue(): void
  {
    if (!this.formControl)
    {
      return;
    }

    const current = this.formControl.value;
    const normalized = this.assessmentService.normalizeFormControlValue(this.field, current);
    // Keep boolean maps (including all-false). Only clear uninterpretable values.
    if (normalized !== undefined && normalized !== null && typeof normalized === 'object' && !Array.isArray(normalized))
    {
      if (current !== normalized)
      {
        this.formControl.setValue(normalized, { emitEvent: false });
      }

      return;
    }

    if (current !== null && current !== undefined)
    {
      this.formControl.setValue(this.assessmentService.getSafeEmptyControlValue(this.field), { emitEvent: false });
    }
  }
}
